<template>
  <div>
    <a-tabs type="card" @change="callback">
      <a-tab-pane key="1" tab="频次设置">
        <frequencySet />
      </a-tab-pane>
      <a-tab-pane key="2" tab="白名单IP">
        <whiteListSet />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import frequencySet from './components/frequencySet/index'
import whiteListSet from './components/whiteListSet/index'
export default {
  components: {
        frequencySet, whiteListSet
  },
  setup (props, { root }) {
    function callback (e) {}

    return {
      callback
    }
  }
}
</script>
<style lang='less'>
.demo {
  border: 1px solid;
}
</style>
